export default {"src":"/_next/static/media/creditcard.71f10f4e.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};